export default __webpack_public_path__ + "static/boiler_b.672d866aa7bc75abbac5d3056e25176c.png";